import { useState } from 'react';
import { Trans, t } from '@lingui/macro';
import { Avatar, Box, Typography, Button, useToast, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { RegenerateSecretPrompt } from './components/RegenerateSecretPrompt';
import { Container, TruncateBox } from './styled';
export function PreviewSecret(props) {
    const { clientSecret, loading, onClick } = props;
    const { addToast } = useToast();
    const [prompt, setPrompt] = useState(false);
    const handleCopy = () => {
        if (clientSecret) {
            navigator.clipboard
                .writeText(clientSecret)
                .then(() => {
                addToast({
                    title: t({
                        message: 'Client secret copied to clipboard!',
                        comment: 'Toast message when client secret copied',
                    }),
                    appearance: 'success',
                });
            })
                .catch(() => {
                addToast({
                    title: t({
                        message: 'Failed to copy client secret to clipboard.',
                        comment: "Toast message when client secret couldn't be copied",
                    }),
                    appearance: 'danger',
                });
            });
        }
    };
    const handleRegenerate = () => {
        onClick();
        setPrompt(false);
    };
    return (<Container $warning={Boolean(clientSecret)}>
      <Avatar size="lg" appearance={clientSecret ? 'warning' : 'light'} solid>
        <Falcon icon="lock"/>
      </Avatar>
      <TruncateBox display="flex" flexDirection="column" width="100%">
        <Typography $fontSize="small">
          <Trans comment="Preview client secret - title">Client secret</Trans>
        </Typography>
        <Typography $appearance="300" $fontSize="huge" $truncate>
          {clientSecret || '################'}
        </Typography>
      </TruncateBox>
      <Box>
        {clientSecret ? (<Button onClick={() => handleCopy()}>
            <Falcon icon="copy"/>
            <Trans comment="Button to copy client secret">Copy</Trans>
          </Button>) : (<RegenerateSecretPrompt open={prompt} onClose={() => setPrompt(false)} onClick={() => handleRegenerate()}>
            <Button onClick={() => setPrompt(true)} appearance="ghost" disabled={loading}>
              {loading ? <Loader /> : <Falcon icon="refresh"/>}
              <Trans comment="Button to regenerate client secret">Regenerate</Trans>
            </Button>
          </RegenerateSecretPrompt>)}
      </Box>
    </Container>);
}
